// Mock data for RAE Association of Tasmania clone
// All content & access-control is mocked here for the frontend-only build.

export const ASSOC = {
  name: "Royal Australian Engineers' Association of Tasmania Inc.",
  shortName: 'RAE Association of Tasmania',
  motto: 'Once a Sapper, Always a Sapper!',
  ubique: 'Ubique',
};

export const IMAGES = {
  groupPhoto: 'https://images.unsplash.com/photo-1571841653714-f542a5e00bdc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxtaWxpdGFyeSUyMHBhcmFkZXxlbnwwfHx8fDE3ODE4OTY5MDF8MA&ixlib=rb-4.1.0&q=85',
  armyTent: 'https://images.unsplash.com/photo-1620058689342-80271a734f23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxhcm15JTIwZW5naW5lZXJzfGVufDB8fHx8MTc4MTg5NjkwMXww&ixlib=rb-4.1.0&q=85',
  bulldozer: 'https://images.pexels.com/photos/10843040/pexels-photo-10843040.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  parade: 'https://images.pexels.com/photos/13433429/pexels-photo-13433429.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  formation: 'https://images.unsplash.com/photo-1608396941316-ea89219bd56e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxtaWxpdGFyeSUyMHBhcmFkZXxlbnwwfHx8fDE3ODE4OTY5MDF8MA&ixlib=rb-4.1.0&q=85',
  vessel: 'https://images.pexels.com/photos/17873297/pexels-photo-17873297.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  memorial: 'https://images.unsplash.com/photo-1714828196863-212245d075a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHx3YXIlMjBtZW1vcmlhbHxlbnwwfHx8fDE3ODE4OTY5MzV8MA&ixlib=rb-4.1.0&q=85',
  mariaIsland: 'https://images.pexels.com/photos/38129444/pexels-photo-38129444.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  tasCoast: 'https://images.unsplash.com/photo-1706593193861-bd3eece69036?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxUYXNtYW5pYSUyMGNvYXN0fGVufDB8fHx8MTc4MTg5NjkzNXww&ixlib=rb-4.1.0&q=85',
  poppy: 'https://images.unsplash.com/photo-1594744842389-171406feb570?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxhbnphYyUyMHBvcHB5fGVufDB8fHx8MTc4MTg5NjkzNXww&ixlib=rb-4.1.0&q=85',
};

// Member classes (lowest -> highest, but access is independent per page)
export const MEMBER_CLASSES = ['public', 'contact', 'deceased', 'resigned', 'no-contact', 'nonfinancial', 'financial', 'committee', 'group-admin', 'site-admin', 'admin'];

export const INACTIVE_CLASSES = ['deceased', 'resigned', 'no-contact'];

export const CLASS_LABELS = {
  public: 'Public',
  contact: 'Contact',
  deceased: 'Deceased',
  resigned: 'Resigned',
  'no-contact': 'No Contact',
  nonfinancial: 'Non-Financial',
  financial: 'Financial',
  committee: 'Committee',
  'group-admin': 'Group Administrator',
  'site-admin': 'Site Administrator',
  admin: 'System Administrator',
};

// Built-in classes as data; admins may add custom classes (stored in site settings).
export const DEFAULT_MEMBER_CLASSES = MEMBER_CLASSES.map((k) => ({ key: k, label: CLASS_LABELS[k], builtin: true }));

// Navigation structure (mirrors original site)
export const NAV_ITEMS = [
  { label: 'Home', path: '/', pageKey: 'home' },
  {
    label: 'Members',
    children: [
      { label: 'Current Members', path: '/members/current', pageKey: 'members-current' },
      { label: 'Members Directory', path: '/members/directory', pageKey: 'members-directory' },
      { label: 'Presidents & Life Members', path: '/members/presidents', pageKey: 'members-presidents' },
      { label: 'Apply for Membership', path: '/members/apply', pageKey: 'members-apply' },
      { label: "Officers & NCOs", path: '/members/officers', pageKey: 'members-officers' },
    ],
  },
  {
    label: 'Publications',
    children: [
      { label: 'Gallery', path: '/publications/gallery', pageKey: 'publications-gallery' },
      { label: 'Slideshow', path: '/publications/slideshow', pageKey: 'publications-slideshow' },
      { label: 'Documents', path: '/publications/documents', pageKey: 'publications-documents' },
    ],
  },
  { label: 'Traditions', path: '/traditions', pageKey: 'traditions' },
  { label: 'Welfare', path: '/welfare', pageKey: 'welfare' },
  {
    label: 'History',
    children: [
      { label: '12 Field Squadron', path: '/history/12-field-squadron', pageKey: 'history-12fs' },
      { label: 'Torpedo Corps', path: '/history/torpedo-corps', pageKey: 'history-torpedo' },
      { label: 'Back to BMTA / Maria Island', path: '/history/maria-island', pageKey: 'history-bmta' },
      { label: 'Memorials', path: '/history/memorials', pageKey: 'history-memorials' },
    ],
  },
  { label: 'Achievements', path: '/achievements', pageKey: 'achievements' },
  { label: 'About', path: '/about', pageKey: 'about' },
  { label: 'Links', path: '/links', pageKey: 'links' },
  { label: 'Contact', path: '/contact', pageKey: 'contact' },
];

// Default access matrix: pageKey -> [allowed classes]. Independent custom sets.
export const DEFAULT_PERMISSIONS = {
  home: ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  about: ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  links: ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  contact: ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  'members-apply': ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  traditions: ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  achievements: ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  'history-12fs': ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  'history-torpedo': ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  'history-bmta': ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  'history-memorials': ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  'members-presidents': ['contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  'publications-gallery': ['nonfinancial', 'financial', 'committee', 'admin'],
  welfare: ['nonfinancial', 'financial', 'committee', 'admin'],
  'members-current': ['financial', 'committee', 'admin'],
  'publications-slideshow': ['financial', 'committee', 'admin'],
  'publications-documents': ['financial', 'committee', 'admin'],
  'members-officers': ['committee', 'admin'],
  admin: ['admin'],
  'admin-permissions': ['admin'],
  'admin-pages': ['admin'],
  'admin-members': ['admin'],
  'admin-email': ['admin'],
  'admin-inbox': ['admin'],
  'admin-renewals': ['admin'],
  'admin-settings': ['admin'],
  'admin-photos': ['admin'],
  'admin-events': ['admin'],
  'admin-google': ['admin'],
  'admin-activity': ['admin'],
  'admin-appearance': ['admin'],
  'admin-banking': ['admin'],
  'admin-organisation': ['admin'],
  'admin-tags': ['admin'],
  'admin-shop': ['admin'],
  'admin-memorabilia': ['committee', 'admin'],
  'memorabilia': ['contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  'admin-subgroups': ['admin'],
  'admin-articles': ['admin'],
  'admin-gallery': ['admin'],
  'admin-governance': ['committee', 'admin'],
  shop: ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
  subgroups: ['public', 'contact', 'nonfinancial', 'financial', 'committee', 'admin'],
};

// Default appearance/layout settings (fallback until backend loads)
export const DEFAULT_SETTINGS = {
  colors: {
    maroon: '#8a0a08', navy: '#15385b', sage: '#c6cabb',
    olive: '#7c7560', gold: '#c9a13b', ink: '#33352f', cream: '#f4f1e8',
  },
  fonts: { title: 'Cardo', body: 'PT Serif' },
  header: {
    title: "Royal Australian Engineers' Association of Tasmania Inc.",
    motto: 'Once a Sapper, Always a Sapper!',
    ubique: 'Ubique',
  },
  layout: { showHomeCards: true, showUbique: true, showSocial: true, hiddenNav: [] },
  content: {},
  menuTree: [],
  customGroups: [],
};

// Curated Google Fonts for the appearance editor
export const FONT_OPTIONS = [
  'Cardo', 'PT Serif', 'Playfair Display', 'Lora', 'EB Garamond',
  'Merriweather', 'Spectral', 'Libre Baskerville', 'Cinzel', 'Roboto Slab',
  'Inter', 'Roboto', 'Open Sans', 'Lato', 'Montserrat',
];

// Demo accounts so reviewers can test access control immediately
export const DEMO_USERS = [
  { id: 'u1', name: 'Guest Visitor', email: 'guest@example.com', memberClass: 'contact', picture: '' },
  { id: 'u2', name: 'John Sapper', email: 'john.sapper@example.com', memberClass: 'nonfinancial', picture: '' },
  { id: 'u3', name: 'Mary Field', email: 'mary.field@example.com', memberClass: 'financial', picture: '' },
  { id: 'u4', name: 'Robert Bridge', email: 'robert.bridge@example.com', memberClass: 'committee', picture: '' },
  { id: 'u5', name: 'Site Administrator', email: 'admin@tassappers.com.au', memberClass: 'admin', picture: '' },
];

// Page content keyed by pageKey
export const PAGES = {
  home: { title: 'Welcome', isHome: true },
  'members-current': {
    title: 'Current Members',
    intro: 'A register of current financial members of the Association. Financial members receive the quarterly newsletter, voting rights and access to all member resources.',
    table: {
      head: ['Name', 'Rank', 'Unit', 'Years Served'],
      rows: [
        ['John Sapper', 'Cpl', '12 Fd Sqn RAE', '1978 - 1985'],
        ['Mary Field', 'Sgt', '12 Fd Sqn RAE', '1980 - 1987'],
        ['Robert Bridge', 'WO2', '12 Fd Sqn RAE', '1972 - 1984'],
        ['Alan Pontoon', 'Spr', '12 Fd Sqn RAE', '1981 - 1987'],
        ['David Mine', 'Lt', '12 Fd Sqn RAE', '1975 - 1983'],
      ],
    },
  },
  'members-presidents': {
    title: 'Presidents & Life Members',
    intro: 'The Association honours those who have given outstanding service through leadership and dedication.',
    list: [
      'Maj (Retd) E. Cornwall - Foundation President',
      'WO1 (Retd) G. Hammer - Life Member',
      'Capt (Retd) R. Trestle - Life Member',
      'Sgt (Retd) P. Charge - Life Member',
    ],
    paragraphs: ['Life Membership is awarded by resolution of the committee in recognition of significant and sustained contribution to the Association and to the broader Sapper community.'],
  },
  'members-apply': {
    title: 'Apply for Membership',
    paragraphs: [
      'Membership of the Royal Australian Engineer\u2019s Association of Tasmania is open to all past, present and future Sappers associated with, or interested in, Tasmania.',
      'To apply, download and complete the membership application form, then return it with the applicable subscription to the Secretary.',
    ],
    cta: { label: 'Download Membership Form (PDF)', note: 'Mocked download \u2014 form will be wired up with the backend.' },
  },
  'members-officers': {
    title: 'Officers & NCOs',
    intro: 'The current Committee of Management and Honorary Officers of the Association.',
    table: {
      head: ['Position', 'Name'],
      rows: [
        ['President', 'Robert Bridge'],
        ['Vice President', 'Mary Field'],
        ['Secretary', 'John Sapper'],
        ['Treasurer', 'Alan Pontoon'],
        ['Welfare Officer', 'David Mine'],
      ],
    },
  },
  'publications-gallery': { title: 'Photo Gallery', isGallery: true },
  'publications-slideshow': {
    title: 'Slideshow',
    intro: 'A rolling slideshow of historic and contemporary Sapper photographs from across the State.',
    isSlideshow: true,
  },
  'publications-documents': {
    title: 'Documents',
    intro: 'Official Association documents available to financial members.',
    docs: [
      { name: 'Association Constitution (2020)', size: '1.2 MB' },
      { name: 'Annual General Meeting Minutes', size: '480 KB' },
      { name: 'Quarterly Newsletter \u2014 Autumn Edition', size: '3.1 MB' },
      { name: 'Treasurer\u2019s Financial Report', size: '760 KB' },
    ],
  },
  traditions: {
    title: 'Traditions',
    image: 'parade',
    paragraphs: [
      'The Royal Australian Engineers carry a proud heritage built on the Corps motto \u201cUbique\u201d \u2014 meaning \u201cEverywhere\u201d \u2014 reflecting the Sapper\u2019s presence wherever the Army serves.',
      'Sapper traditions are kept alive through the observance of Corps days, the wearing of the Corps colours, and the time-honoured greeting: \u201cOnce a Sapper, Always a Sapper.\u201d',
      'Our Association maintains these customs at reunions, commemorations and ceremonial occasions throughout Tasmania.',
    ],
  },
  welfare: {
    title: 'Welfare',
    image: 'armyTent',
    paragraphs: [
      'The welfare of our members and their families is central to the work of the Association.',
      'Our Welfare Officer can assist members with referrals to DVA, advocacy support, and connection to local ex-service organisations.',
      'If you or a fellow Sapper needs assistance, please reach out \u2014 no Sapper is left behind.',
    ],
  },
  'history-12fs': {
    title: '12 Field Squadron RAE',
    image: 'bulldozer',
    paragraphs: [
      'Tasmania has a continuous military engineering heritage dating from the first European settlement until 12 Field Squadron RAE was disbanded in December 1987.',
      '12 Field Squadron provided combat engineering support including bridging, demolitions, watermanship and field defences, training across Tasmania and on the mainland.',
      'This page preserves the operational and training history of the Squadron for future generations of Sappers.',
    ],
  },
  'history-torpedo': {
    title: 'Torpedo Corps',
    image: 'vessel',
    paragraphs: [
      'The Tasmanian Torpedo Corps formed part of the colony\u2019s coastal defences in the late 19th century, operating submarine mining and torpedo defences to protect the Derwent and Tamar estuaries.',
      'The Corps represents one of the earliest expressions of military engineering in Tasmania and a direct forebear of the modern Royal Australian Engineers.',
    ],
  },
  'history-bmta': {
    title: 'Back to BMTA / Maria Island',
    image: 'mariaIsland',
    paragraphs: [
      'Maria Island and the former Brighton Military Training Area (BMTA) hold a special place in the training history of Tasmanian Sappers.',
      'Generations of engineers conducted bridging camps, demolitions practice and field exercises across these sites. Our \u201cBack to\u201d reunions return members to these historic grounds.',
    ],
  },
  'history-memorials': {
    title: 'Memorials',
    image: 'memorial',
    paragraphs: [
      'We remember the Sappers of Tasmania who served and those who paid the ultimate sacrifice.',
      'The Association supports the maintenance of memorials and the observance of commemorative services, ensuring their service is never forgotten.',
    ],
    quote: 'Lest We Forget',
  },
  achievements: {
    title: 'Achievements',
    image: 'formation',
    paragraphs: [
      'The Association is proud of its record in preserving Tasmania\u2019s military engineering heritage.',
    ],
    list: [
      'Establishment of the State Sapper memorial register',
      'Digitisation of the 12 Field Squadron photographic archive',
      'Annual commemoration services across Tasmania',
      'Successful \u201cBack to Maria Island\u201d reunion program',
      'Welfare support and advocacy for veteran members',
    ],
  },
  about: {
    title: 'About Us',
    paragraphs: [
      'The Royal Australian Engineer\u2019s Association of Tasmania Inc. exists to support all past, present and future Sappers associated with, or interested in, Tasmania.',
      'We see it as an important function of our Association to continue to preserve this State\u2019s military engineering heritage and traditions.',
      'This website provides a repository for members and a single contact point to preserve and administer this heritage.',
    ],
  },
  links: {
    title: 'Useful Links',
    linkList: [
      { name: 'Royal Australian Engineers (Army)', url: 'https://www.army.gov.au/about-us/army-corps/royal-australian-engineers' },
      { name: 'Department of Veterans\u2019 Affairs', url: 'https://www.dva.gov.au/' },
      { name: 'RSL Tasmania', url: 'https://www.rsltas.org.au/' },
      { name: 'Australian War Memorial', url: 'https://www.awm.gov.au/' },
      { name: 'RAE Association (National)', url: 'https://rae.org.au/' },
    ],
  },
  contact: { title: 'Contact Us', isContact: true },
};
